<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Kategori' : 'Tambah Kategori' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="categoryName" id="category-name" label="Nama Kategori"
          placeholder="Masukkan nama kategori" input_class="w-full" :valid="validation.name.valid"
          :error-message="validation.name.message" />
        <div class="my-3">
          <label for="divisi" class="font-medium text-dark-600 dark:text-dark-400">Divisi Kitchen</label>
          <div class="my-2 flex flex-wrap justify-start gap-4">
            <div v-for="(item, index) in allKitchenDivisions" :key="index" class="flex items-center gap-2">
              <Checkbox v-model="checkedCategoryDivision" :input-id="index + '_division'" name="division" :value="item.id"
                :class="!validation.printer_list.valid ? 'p-invalid' : ''" />
              <label :for="index + '_division'" class="text-dark-600 dark:text-dark-400"> {{ item.name }} </label>
            </div>
            <Message v-if="!validation.printer_list.valid" size="small" severity="error" variant="simple">{{
              validation.printer_list.message }}
            </Message>
          </div>
        </div>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitCategory" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions, mapGetters } from 'vuex';
import InputTextCustom from '../form/InputTextCustom.vue';
import { Checkbox } from 'primevue';

export default {
  name: "ModalCategory",
  props: {
    category: {
      type: Object,
      default: null,
    }
  },
  components: {
    SubmitButton, InputTextCustom, Checkbox
  },
  data() {
    return {
      showModal: true,
      categoryName: this.category ? this.category.name : '',
      categoryDivision: this.category ? this.category.printer_list || [] : [],
      checkedCategoryDivision: this.category ? this.category.printer_list.map(item => item.id) : [],
      categoryStatus: this.category ? this.category.status : 'active',
      isEdit: !!this.category,
      validation: {
        name: {
          valid: true,
          message: ''
        },
        printer_list: {
          valid: true,
          message: ''
        }
      },
      field: ['name', 'printer_list'],
    };
  },
  computed: {
    ...mapGetters('kitchen_divisions', ['allKitchenDivisions']),
    categoryChecked() {
      return this.categoryDivision.map(item => item.id);
    }
  },
  created() {
    this.$store.dispatch('kitchen_divisions/fetchKitchenDivisions', { limit: 1000});
  },
  watch: {
    category(newValue) {
      if (newValue) {
        this.categoryName = newValue.name;
        this.categoryDivision = newValue.divisi || [];
        this.categoryStatus = newValue.status;
        this.isEdit = true;
      } else {
        this.categoryName = '';
        this.categoryDivision = [];
        this.categoryStatus = true;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('item_categories', ['createItemCategory', 'updateItemCategory']),
    ...mapActions('kitchen_divisions', ['fetchKitchenDivisionById']),
    closeModal() {
      this.showModal = false;
      this.$emit('closeModal');
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitCategory() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan Kategori Item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postItemCategory();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan kategori', life: 3000 });
        }
      });
    },
    async postItemCategory() {
      try {
        const division = await Promise.all(
          this.checkedCategoryDivision.map(async (element) => {
            const kitchen = await this.fetchKitchenDivisionById(element);
            return {
              id: kitchen.data.id,
              name: kitchen.data.name,
              printer_ip: kitchen.data.printer_ip
            };
          })
        );

        const categoryData = {
          name: this.categoryName,
          printer_list: division,
          status: this.categoryStatus
        };
        console.log(categoryData);

        if (this.isEdit && this.category) {
          categoryData.id = this.category.id;
          await this.updateItemCategory(categoryData);
        }
        else {
          await this.createItemCategory(categoryData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Kategori berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save category: ', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>